


















































import { Component, Vue, Prop } from 'vue-property-decorator'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage,
  queryOrderDetailById,
  completeOrder,
  deliveryOrder,
  orderCancel,
  orderReject,
  orderAccept,
  getOrderListBy,
} from '@/api/order'
@Component({
  name: 'Orderview',
  components: {
    Empty,
  },
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics!: any
  @Prop() private orderData!: any

  private orderId = '' //订单号
  private dialogOrderStatus = 0 //弹窗所需订单状态，用于详情展示字段
  private activeIndex = 0

  private dialogVisible = false //详情弹窗
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private diaForm = []
  private row = {}
  private isAutoNext = true
  private isSearch: boolean = false
  private counts = 0
  private page: number = 1
  private pageSize: number = 10
  private status = 2
  // private orderData = []
  private isTableOperateBtn = true
  // created() {
  //   this.getOrderListData(this.status)
  // }
  // // 获取订单数据
  // async getOrderListData(status) {
  //   const params = {
  //     page: this.page,
  //     pageSize: this.pageSize,
  //     status: status,
  //   }
  //   const data = await getOrderListBy()
  //   this.orderData = data.data.data.orders
  //   // this.counts = data.data.data.total
  //   this.$emit('getOrderListBy3Status')
  //   // if (
  //   //   this.dialogOrderStatus === 2 &&
  //   //   this.status === 2 &&
  //   //   this.isAutoNext &&
  //   //   !this.isTableOperateBtn &&
  //   //   data.data.records.length > 1
  //   // ) {
  //   //   const row = data.data.records[0]
  //   //   this.goDetail(row.id, row.status, row, row)
  //   // } else {
  //   //   return null
  //   // }
  // }

  // 关闭弹层
  handleClose() {
    this.dialogVisible = false
  }
  // 分页
  // private handleSizeChange(val: any) {
  //   this.pageSize = val
  //   this.getOrderListData(this.status)
  // }

  // private handleCurrentChange(val: any) {
  //   this.page = val
  //   this.getOrderListData(this.status)
  // }
}
